import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/team-lead/flag-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-3675245c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container",
  role: "main",
  "data-test": "team-lead-area"
}
const _hoisted_2 = {
  key: 2,
  class: "team-lead-grid"
}
const _hoisted_3 = { "data-test": "milestone-title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "grid-item",
  "data-test": "team-lead-levels"
}
const _hoisted_6 = { class: "level-header" }
const _hoisted_7 = { class: "header-text" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "level-content" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Uplifts", -1))
const _hoisted_12 = { class: "uplifts" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Practicalities", -1))
const _hoisted_15 = { class: "practicalities" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "level-button-container" }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "complete-error-message"
}
const _hoisted_23 = { class: "text-center text-danger" }
const _hoisted_24 = {
  class: "milestone-modal",
  "data-test": "milestone-modal"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "New Milestone!", -1))
const _hoisted_26 = { class: "milestone-badge" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Milestone Flag"
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Milestone", -1))

import {
  computed,
  inject,
  nextTick,
  onBeforeUnmount,
  onMounted,
  onUnmounted,
  provide,
  Ref,
  ref,
  triggerRef,
  watch,
  watchEffect,
} from "vue";
import { Modal } from "uiv";
import axios, { AxiosError } from "axios";
import { debug as d } from "debug";
import CompletableAccordion from "../../components/reusables/completable-accordion.vue";
import cms from "../../services/cms/cms";
import { CmsDocumentTypes } from "../../services/cms/cms-type-configuration";
import { TeamCompletedLevelsAndMilestonesApiModel } from "../../api-models";
import { csContext } from "../../services/cs-context";
import LoadingPage from "../loading-page.vue";
import ProgressCircle from "../../components/reusables/progress-circle.vue";
import useTeamLeadLevels, {
  CurrentPathwayIds,
  LevelItem,
} from "../../composables/useTeamLeadLevels";
import { useToggle } from "../../composables/useToggle";
import TeamInviteModal from "../../components/invite-control/team-invite-modal.vue";
import { Analytics } from "../../services/analytics/analytics";
import errorRedirect from "../../services/utilities/error-redirect";
import { CmsTeamLevelData } from "../../services/cms/cms-type-definitions";
import LoadingSpinner from "../../components/loading-spinner.vue";
import InitiateRequestModal from "../../components/team-lead-area/initiate-request-modal.vue";
import InfoIcon from "../../components/info-icon.vue";
import useNotification, { SentRequestNotification } from "../../composables/useNotification";
import AvatarList from "../../components/team-lead-area/avatar-list.vue";
import CompleteLevelModal from "../../components/team-lead-area/complete-level-modal.vue";
import localStorageService from "../../services/utilities/local-storage-service";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-lead-area',
  setup(__props) {

const debug = d("cs.TeamLeadArea");

const userIsTeamLeader = inject("userIsTeamLeader") as Ref<boolean>;

const teamId = computed(() => csContext.currentTeam?.id);

const teamLevelsAreInactive = computed(() => !teamId.value || !userIsTeamLeader.value);

const isLoading = ref(true);
const levels = ref<LevelItem[]>([]) as Ref<LevelItem[]>;
const showMilestoneModal = ref(false);

const scrollPosition = ref(0);

const updateScroll = () => {
  scrollPosition.value = window.scrollY;
  localStorageService.save("teamLeadScrollPosition", scrollPosition.value);
};

const {
  prepareLevelsAndMilestones,
  setLevelsStatus,
  castAsLevel,
  setLevelLink,
  completeLevel,
  getCurrentPathwayIds,
} = useTeamLeadLevels();

const { getSentRequestNotificationsForTeam } = useNotification();

const { state: isTeamInviteModalOpen, toggleState: toggleTeamInviteModal } = useToggle(false);

const activeLevel = computed(() => levels.value.find((level) => level.status === "active"));
const levelOrMilestoneNumber = computed(() => activeLevel.value?.number);

const selectedLevel = ref<LevelItem>(
  levels.value.find((level) => level.status === "active") || ({} as LevelItem),
);
provide("selectedLevel", selectedLevel);

const completeErrorMessage = ref("");
const isSavingCompletion = ref(false);

const levelsCompleted = computed(() => {
  return (
    levels.value.filter((level) => level.status === "completed" && level.type === "level").length +
    1
  );
});

function onGoClick(levelData: CmsTeamLevelData, level: LevelItem) {
  if (levelData.level_type === "session") {
    return;
  }
  // can get rid of this button once the invite level becomes a session
  if (levelData.level_type === "team-invite-modal") {
    selectedLevel.value = level;
    toggleTeamInviteModal();
  }
}

async function getTeamLevelsProgress() {
  const response = await axios.get<TeamCompletedLevelsAndMilestonesApiModel>(
    `/api/teamlevels/${csContext.currentTeam?.id}`,
  );

  return response.data;
}

function onAccordionClose(id: string) {
  const index = levels.value.findIndex((level) => level.id === id);
  if (index !== -1) {
    levels.value[index] = { ...levels.value[index], isOpen: false };
    triggerRef(levels);
  }
  localStorageService.save("teamLeadOpenLevelId", null);
}

function onAccordionOpen(id: string) {
  const openLevel = levels.value.find((level) => level.id === id);
  localStorageService.save("teamLeadOpenLevelId", id);
  levels.value = levels.value.map((level) => ({
    ...level,
    isOpen: level.id === id,
  }));
  Analytics.action("Expanded Level Content", "TeamLeadAreaActions", {
    levelTitle: cms.asText(openLevel?.data.title),
    levelNumber: openLevel?.number,
    levelStatus: openLevel?.status,
  });
}

const currentPathwayIds = ref<CurrentPathwayIds>({
  teamPathway: {
    id: "",
    stepOneId: "",
    stepTwoId: "",
  },
  personalPathway: {
    id: "",
    stepOneId: "",
    stepTwoId: "",
  },
});

const sentNotifications = ref<SentRequestNotification[]>([]);

const { state: isInitiateRequestModalOpen, toggleState: toggleInitiateRequestModal } =
  useToggle(false);

const { state: showLevelModal, toggleState: toggleShowLevelModal } = useToggle(false);

function openInitiateRequestModal(level: LevelItem) {
  selectedLevel.value = level;
  toggleInitiateRequestModal();
}

async function closeInitiateRequestModal(triggerRefresh: boolean) {
  toggleInitiateRequestModal();
  if (triggerRefresh) {
    currentPathwayIds.value = await getCurrentPathwayIds(teamId.value);
    sentNotifications.value = await getSentRequestNotificationsForTeam(teamId.value);
    // refreshPage();
  }
}

function getActionType(level: LevelItem): "Pathway" | "Resource" | "Invite" {
  const castedLevel = castAsLevel(level.data);
  if (
    castedLevel.requires_team_action === "personal pathway step" ||
    castedLevel.requires_team_action === "team pathway step"
  ) {
    return "Pathway";
  }
  if (castedLevel.level_type === "team-invite-modal") {
    return "Invite";
  }
  return "Resource";
}

function displayAvatarList(level: LevelItem): boolean {
  const castedLevel = castAsLevel(level.data);
  const requiresAction =
    castedLevel.requires_team_action !== undefined && castedLevel.requires_team_action !== "none";

  // if the level action is a pathway step we need to check if the pathway has been initiated
  if (requiresAction) {
    const pathwayStepId = castedLevel.action_resource_link?.id;
    return (
      pathwayStepId === currentPathwayIds.value.teamPathway.stepOneId ||
      pathwayStepId === currentPathwayIds.value.teamPathway.stepTwoId ||
      pathwayStepId === currentPathwayIds.value.personalPathway.stepOneId ||
      pathwayStepId === currentPathwayIds.value.personalPathway.stepTwoId
    );
  }

  return castedLevel.level_type === "team-invite-modal";
}

function processedDescription(level: LevelItem): string {
  const desc = cms.asHtml(castAsLevel(level.data).description);
  const htmlString = desc.replace(/for <strong><span>UNKNOWN_TEAM<\/span><\/strong>/g, "");
  return htmlString.replace(/\s+\./g, ".");
}

function displayCompleteButton(level: LevelItem): boolean {
  if (level.status === "completed" || teamLevelsAreInactive.value) {
    return false;
  }

  const castedLevel = castAsLevel(level.data);

  const levelRequiresPathwayInitiation = castedLevel.initiate_pathway ?? false;
  const levelRequiresResourceRequest = castedLevel.requires_team_action === "view resource";

  if (levelRequiresPathwayInitiation) {
    return castedLevel.pathway_type === "team"
      ? castedLevel.pathway_to_initiate?.id === currentPathwayIds.value.teamPathway.id
      : castedLevel.pathway_to_initiate?.id === currentPathwayIds.value.personalPathway.id;
  }

  if (levelRequiresResourceRequest) {
    const isResourceRequestSent = sentNotifications.value.find(
      (notification) => notification.resourceId === castedLevel.action_resource_link?.id,
    );
    return !!isResourceRequestSent;
  }

  return true;
}

function displayInfoIcon(level: LevelItem): boolean {
  if (level.status === "completed" || teamLevelsAreInactive.value) {
    return false;
  }

  return castAsLevel(level.data).initiate_pathway && !displayCompleteButton(level);
}

function displayRequestInitiationButton(level: LevelItem): boolean {
  if (level.status === "completed" || teamLevelsAreInactive.value) {
    return false;
  }

  const casted = castAsLevel(level.data);

  return (
    !displayCompleteButton(level) &&
    (casted.initiate_pathway || casted.requires_team_action === "view resource")
  );
}

function applyDefaultClass(level: LevelItem): boolean {
  const parsed = castAsLevel(level.data);
  if (!parsed.initiate_pathway) {
    return false;
  }
  return displayCompleteButton(level);
}

async function complete(level: LevelItem) {
  if (isSavingCompletion.value) {
    return;
  }

  isSavingCompletion.value = true;
  const { status, errorMessage } = await completeLevel(level, teamId.value);
  if (status.value === "error") {
    completeErrorMessage.value = errorMessage.value;
    isSavingCompletion.value = false;
  }

  if (status.value === "success") {
    isSavingCompletion.value = false;
    toggleShowLevelModal();
  }
}

async function getLevelsData() {
  const response = await cms.getByUid(
    CmsDocumentTypes.CmsTeamLevelsAndMilestones,
    "team-lead-area-master-list",
  );
  return prepareLevelsAndMilestones(response.data.team_levels_and_milestones_list);
}

async function getAndSetTeamLevels() {
  try {
    const [levelsResponse, progressResponse, currentPathways, notifications] = await Promise.all([
      getLevelsData(),
      getTeamLevelsProgress(),
      getCurrentPathwayIds(teamId.value),
      getSentRequestNotificationsForTeam(teamId.value),
    ]);
    levels.value = levelsResponse;
    currentPathwayIds.value = currentPathways;
    sentNotifications.value = notifications;
    if (progressResponse) {
      setLevelsStatus(levels.value, progressResponse);
    }
  } catch (e: unknown) {
    const error = e as AxiosError;
    debug(error.message);
    errorRedirect(error.response?.status || 500);
  } finally {
    isLoading.value = false;
    nextTick(() => {
      window.scrollTo(0, localStorageService.get("teamLeadScrollPosition") || 0);
    });
  }
}

watch(
  userIsTeamLeader,
  async () => {
    window.addEventListener("scroll", updateScroll);
    if (!userIsTeamLeader.value) {
      debug("Team Lead Area mounted");
      try {
        levels.value = (await getLevelsData()) as LevelItem[];
      } catch (e: unknown) {
        const error = e as AxiosError;
        debug(error.message);
        errorRedirect(error.response?.status || 500);
      } finally {
        isLoading.value = false;
      }
      return;
    }

    getAndSetTeamLevels();
  },
  { immediate: true },
);

function refreshPage() {
  window.location.reload();
}

function closeLevelModal() {
  toggleShowLevelModal();
  refreshPage();
}

function closeTeamInviteModal(triggerRefresh: boolean) {
  toggleTeamInviteModal();
  if (triggerRefresh) {
    refreshPage();
  }
}

async function completeMilestone() {
  try {
    await axios.post("/api/teamlevels/CompleteMilestone", {
      prismicId: activeLevel.value?.id,
      prismicUid: activeLevel.value?.uid,
      teamId: csContext.currentTeam?.id,
      title: cms.asText(activeLevel.value?.data.title),
      milestoneNumber: activeLevel.value?.number,
    });
  } catch (e) {
    const error = e as AxiosError;
    debug(error.message);
  }
}

watch(levels, async () => {
  if (activeLevel.value?.type === "milestone") {
    await completeMilestone();
    showMilestoneModal.value = true;
  }
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", updateScroll);
});

onUnmounted(() => {
  localStorageService.save("teamLeadScrollPosition", scrollPosition.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isTeamInviteModalOpen))
      ? (_openBlock(), _createBlock(TeamInviteModal, {
          key: 0,
          "model-value": _unref(isTeamInviteModalOpen),
          onCloseModal: closeTeamInviteModal
        }, null, 8, ["model-value"]))
      : _createCommentVNode("", true),
    (_unref(isInitiateRequestModalOpen))
      ? (_openBlock(), _createBlock(InitiateRequestModal, {
          key: 1,
          "model-value": _unref(isInitiateRequestModalOpen),
          onCloseRequestModal: closeInitiateRequestModal
        }, null, 8, ["model-value"]))
      : _createCommentVNode("", true),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(levels.value, (level) => {
            return (_openBlock(), _createElementBlock("div", {
              key: level.id,
              class: "grid-row"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["grid-item level-circle", level.status])
              }, [
                (level.type === 'level')
                  ? (_openBlock(), _createBlock(ProgressCircle, {
                      key: 0,
                      variant: "team",
                      number: level.number,
                      status: level.status
                    }, null, 8, ["number", "status"]))
                  : _createCommentVNode("", true)
              ], 2),
              (level.type === 'milestone')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["grid-item milestone", level.status]),
                    "data-test": "team-lead-milestones"
                  }, [
                    _createElementVNode("h4", _hoisted_3, [
                      _createTextVNode(_toDisplayString(_unref(cms).asText(level.data.title)) + " ", 1),
                      (level.status === 'completed')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(Array.from({ length: level.number }, () => "🎉").join("")), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(CompletableAccordion, {
                      id: level.id,
                      status: level.status,
                      variant: "team",
                      "is-open": level.isOpen,
                      onAccordionOpened: onAccordionOpen,
                      onAccordionClosed: onAccordionClose
                    }, {
                      trigger: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("h6", {
                              class: _normalizeClass(level.status),
                              "data-test": "level-number"
                            }, "Level " + _toDisplayString(level.number) + ":", 3),
                            _createElementVNode("div", {
                              innerHTML: _unref(cms).asHtml(level.data.title),
                              class: _normalizeClass(["level-title", level.status]),
                              "data-test": "level-title"
                            }, null, 10, _hoisted_8)
                          ]),
                          (displayAvatarList(level) && teamId.value)
                            ? (_openBlock(), _createBlock(AvatarList, {
                                key: 0,
                                "team-id": teamId.value,
                                "resource-id": _unref(castAsLevel)(level.data).action_resource_link?.id,
                                "action-type": getActionType(level)
                              }, null, 8, ["team-id", "resource-id", "action-type"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", {
                            innerHTML: processedDescription(level)
                          }, null, 8, _hoisted_10),
                          _hoisted_11,
                          _createElementVNode("ul", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(castAsLevel)(level.data).uplifts_list, (uplift, index) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: index,
                                innerHTML: _unref(cms).asHtml(uplift.uplift)
                              }, null, 8, _hoisted_13))
                            }), 128))
                          ]),
                          _hoisted_14,
                          _createElementVNode("ul", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(castAsLevel)(level.data).practicalities_list, (practicality, index) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: index,
                                innerHTML: _unref(cms).asHtml(practicality.practicality)
                              }, null, 8, _hoisted_16))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            (_unref(castAsLevel)(level.data).level_type === 'session' && !teamLevelsAreInactive.value)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: _unref(setLevelLink)(level),
                                  class: _normalizeClass(["btn", [
                    applyDefaultClass(level) ? 'btn-default-forward' : 'btn-primary-forward',
                  ]]),
                                  "data-test": "level-go-to-session-button"
                                }, _toDisplayString(_unref(cms).asText(_unref(castAsLevel)(level.data).go_button_text)), 11, _hoisted_18))
                              : (!teamLevelsAreInactive.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    onClick: ($event: any) => (onGoClick(_unref(castAsLevel)(level.data), level)),
                                    class: "btn btn-primary-forward",
                                    type: "button",
                                    "data-test": "level-go-to-other-action-button"
                                  }, _toDisplayString(_unref(cms).asText(_unref(castAsLevel)(level.data).go_button_text)), 9, _hoisted_19))
                                : _createCommentVNode("", true),
                            (displayRequestInitiationButton(level))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  onClick: ($event: any) => (openInitiateRequestModal(level)),
                                  class: "btn btn-default",
                                  type: "button",
                                  "data-test": "level-initiate-request-button"
                                }, _toDisplayString(_unref(castAsLevel)(level.data).initiate_pathway ? "Initiate Pathway" : "Notify Team"), 9, _hoisted_20))
                              : _createCommentVNode("", true),
                            (displayInfoIcon(level))
                              ? (_openBlock(), _createBlock(InfoIcon, {
                                  key: 3,
                                  "icon-width": "16px",
                                  "tooltip-text": "Once you've visited the preparation session you'll understand what 'Initiate Pathway' means!",
                                  name: "initiate-pathway-info-icon"
                                }))
                              : _createCommentVNode("", true),
                            (displayCompleteButton(level))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 4,
                                  onClick: ($event: any) => (complete(level)),
                                  class: _normalizeClass(["btn", [
                    _unref(castAsLevel)(level.data).initiate_pathway
                      ? 'btn-primary-tick'
                      : 'btn-default-tick',
                  ]]),
                                  type: "button",
                                  "data-test": "level-complete-button"
                                }, [
                                  (isSavingCompletion.value)
                                    ? (_openBlock(), _createBlock(LoadingSpinner, {
                                        key: 0,
                                        size: "15px"
                                      }))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(isSavingCompletion.value ? "" : "Complete"), 1)
                                ], 10, _hoisted_21))
                              : _createCommentVNode("", true)
                          ]),
                          (completeErrorMessage.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("p", _hoisted_23, _toDisplayString(completeErrorMessage.value), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["id", "status", "is-open"])
                  ]))
            ]))
          }), 128)),
          (_unref(showLevelModal))
            ? (_openBlock(), _createBlock(CompleteLevelModal, {
                key: 0,
                variant: "team",
                "levels-completed": levelsCompleted.value,
                "model-value": _unref(showLevelModal),
                onCloseCompleteLevelModal: closeLevelModal
              }, null, 8, ["levels-completed", "model-value"]))
            : _createCommentVNode("", true),
          (showMilestoneModal.value)
            ? (_openBlock(), _createBlock(_unref(Modal), {
                key: 1,
                modelValue: showMilestoneModal.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showMilestoneModal).value = $event)),
                header: false,
                footer: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", null, [
                      _hoisted_25,
                      _createElementVNode("p", null, "Congratulations on Milestone " + _toDisplayString(levelOrMilestoneNumber.value) + ". Keep up the good work!", 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("h4", null, _toDisplayString(levelOrMilestoneNumber.value), 1),
                      _hoisted_28
                    ]),
                    _createElementVNode("div", { style: {"margin-bottom":"10px"} }, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: refreshPage,
                        type: "button",
                        "data-test": "milestone-modal-button"
                      }, " Continue ")
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock(LoadingPage, { key: 3 }))
  ]))
}
}

})